import React from "react";
import ReactDOM from "react-dom/client";
import "./index.scss";
import reportWebVitals from "./reportWebVitals";
import App from "./App";

import "./i18n";
import { initDB } from "react-indexed-db-hook";
import { HelmetProvider } from "react-helmet-async";
import { dbVersion, loadDBVersion } from "./configLoader";
import { createDBConfig } from "./model/DBConfig";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

const startApp = async () => {
    await loadDBVersion();

    initDB(createDBConfig(dbVersion));

    root.render(
        <HelmetProvider>
            <App />
        </HelmetProvider>
    );
};

startApp();

if (window._env_.REACT_APP_ENVIRONMENT === "development") {
    reportWebVitals(console.log);
}
